import React, { useEffect, useMemo, useRef, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import PropTypes from 'prop-types';
import DeleteSelectedLedger from '../../components/modals/DeleteSelectedLedger';
import {
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Typography,
  Paper,
  Checkbox,
  IconButton,
  Fade,
  CircularProgress,
  Button,
  Backdrop,
  Tooltip,
  Skeleton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';

import {
  Clear,
  GroupWork,
  CommitSharp,
  Delete,
  Cloud,
  CloudDone,
  Edit,
  EditOff,
  Accessibility,
  Accessible,
  DirectionsRun,
  CheckCircleOutline,
  DoDisturbAlt,
  ArrowCircleRight,
} from '@mui/icons-material';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { display } from '../../redux/reducers/sidebar';
import ConfirmDeleteModal from '../../components/modals/ConfirmDeleteModal';
import { API, graphqlOperation } from 'aws-amplify';
import { getTransactionMaster, listAccountTransactionDetails } from '../../graphql/queries';
import { useLocation } from 'react-router-dom';
import MuiAlert from '@mui/material/Alert';
import { ThreeDot } from '../../components/DropDown/ThreeDot';

import { showErrorSnackbar, showSuccessSnackbar, showWarningSnackbar } from '../../components/snackBar/snakbar';
import moment from 'moment/moment';
import DropDownForListing from '../../components/DropDown/DropDown';
import { MoneyFormat, MoneyFormatv3 } from '../../library/MoneyFormat';
import CreateLedger from '../../components/modals/CreateLedger';
import EditToAccount from '../../components/modals/EditToAccountModal';

import { useSelector } from 'react-redux';
import { ListSelection_fnForMasters } from '../../library/ListSelection';
import DeleteLedgerGroup from '../../components/modals/DeleteLedgerGroup';
import ListOfAccountGroups from '../../library/ListOfAccountGroups';
import UpdateLedgerGroup from '../../components/modals/UpdateLedgerGroup';
import AddNewPartyModal from '../PrimeFigma/Modals/AddNewPartyModal';
import { defaultRowsPerPage, defaultRowsPerPageOptions, formatNumber, handleFreeze } from '../../utils/common';
import ListingActive from '../../components/modals/ListingActive';
import { settingsClose } from '../../redux/reducers/companySkipSave';
import { useThemes } from '../../components/Theme/theme';
import {
  listAccountMasterv2Api,
  useCreateAccountGSTDetailsMutation,
  useCreateAccountMasterMutation,
  useDeleteAccountMasterMutation,
  useListAccountMasterv2Query,
  useUpdateAccountMasterMutation,
} from '../../redux/apis/accountMaster.api';
import { listAccountBalanceApi, useListAccountBalanceQuery } from '../../redux/apis/listAccountBalance.api';
import { LedgerTransactionModalv2 } from '../LedgerTransaction';
import TableSearchButton from '../PrimeFigma/Components/TableSearchButton';
import { TableCell } from '../../components/Table/TableCell';
import { LedgerModal, useLedgerModalHandle } from '../../features/AccountsAndGroups';
import { formatUnixTimestamp } from '../../library';
import { globalColors } from '../../App';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
function descendingComparator(a, b, orderBy) {
  if (orderBy === 'accountcreationdate') {
    const dateA = new Date(a[orderBy]);
    const dateB = new Date(b[orderBy]);

    if (dateB < dateA) {
      return -1;
    }
    if (dateB > dateA) {
      return 1;
    }
    return 0;
  } else {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
}

function getComparator(order, orderBy) {
  // console.log(orderBy, "!!orderby");

  return (a, b) => {
    const valueA = a[orderBy];
    const valueB = b[orderBy];

    console.log({ valueA, valueB });

    if (!isNaN(valueA) && !isNaN(valueB)) {
      return order === 'asc' ? valueA - valueB : valueB - valueA;
    }

    const strA = typeof valueA === 'string' ? valueA.toLowerCase() : '';
    const strB = typeof valueB === 'string' ? valueB.toLowerCase() : '';

    return order === 'asc' ? strA.localeCompare(strB) : strB.localeCompare(strA);
  };
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCell = [
  {
    id: 'accountname',
    numeric: false,
    disablePadding: true,
    label: 'Ledger Name',
    width: '130px',
  },
  {
    id: 'accountgroupname',
    numeric: false,
    disablePadding: false,
    label: 'Group Name',
    width: '130px',
  },
  {
    id: 'Accounttypecd',
    numeric: false,
    disablePadding: false,
    label: 'Type',
    width: '170px',
  },

  {
    id: 'accountbalance',
    numeric: true,
    disablePadding: false,
    label: 'Account Balance',
    width: '130px',
  },

  {
    id: 'accountcreationdate',
    numeric: false,
    disablePadding: false,
    label: 'Created Date',
    width: '130px',
  },
  {
    id: 'Action',
    numeric: false,
    disablePadding: false,
    label: 'Actions',
    width: '130px',
  },
];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, onDelete, setEnableSearch, setShowActions,scroll,showActions} = props;
  const { theme } = useThemes();

  const [headCellSettings, setHeadCellSettings] = useState(headCell);

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);

  async function getCompanyDetails() {
    try {
      let nonGstHeadCell = [];
      if (getCompany?.relatedcompanydetailsnew?.[0]?.registrationtype == 1) {
        nonGstHeadCell = headCell.filter((ele, key) => {
          if (ele?.id !== 'GSTCategory' && ele?.id !== 'GSTIN') {
            return ele;
          }
        });
        setHeadCellSettings(nonGstHeadCell);
      }
    } catch (error) {
      console.log('error', error);
    }
  }
  useEffect(() => {
    getCompanyDetails();
  }, []);

  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);
  console.log(scroll,"****scroll")

  return (
    <TableRow
      className="noTableCellBorder"
      sx={{
        '.MuiTableCell-root': {
          backgroundColor: `${theme.palette.background.tablebg} !important`,
          fontSize: '14px',
        },
        '& .MuiTableCell-head': {
          top: 0,
          zIndex: 2,
          padding: '2px 10px',
          borderBottom: '0px',
        },
        padding: '0px',
        '& .MuiCheckbox-root': {
          padding: '4px',
        },
        backgroundColor: 'background.tablebg',
        height: '35px',
      }}
    >
      <TableCell
      // padding="checkbox"
      // sx={{
      //   ".css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root": {
      //     padding: "5px",
      //   },
      // }}
      >
        <Checkbox
          sx={{ color: 'input.border' }}
          indeterminate={numSelected > 0 && numSelected < rowCount}
          checked={rowCount > 0 && numSelected === rowCount}
          onChange={onSelectAllClick}
          inputProps={{
            'aria-label': 'select all desserts',
          }}
          size="small"
        />
      </TableCell>
      {headCellSettings.map((headCell) => (
        <TableCell
          key={headCell.id}
          align={headCell.numeric ? 'right' : 'left'}
          padding={headCell.disablePadding ? 'none' : 'normal'}
          sortDirection={orderBy === headCell.id ? order : false}
          sx={{
            minWidth: headCell.width,
            position: headCell.id === 'Action' ? 'sticky' : '',
            right: headCell.id === 'Action' ? 0 : '',
            // borderLeft: headCell.id === "Action" ? "1px solid" : "0px",
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent:headCell.id === "Action" ? "center" : 'space-between',
              alignItems: 'center',
              flexDirection: headCell.numeric ? 'row-reverse' : '',
              // border: headCell.id === "Action" ? "1px solid black" : "",
              borderRadius:headCell.id === "Action" ? "3px" : "",
              width:"100%",
              backgroundColor:headCell.id === "Action" ? "white" : 'background.tablebg',
              boxShadow: (headCell.id === "Action") && (scroll) ?  "0px 4px 8px rgba(0, 0, 0, 0.6)" : "",
                 "&:active": 
                {
                  transform: scroll ? "scale(0.92)":"scale(1)",
                },
            }}
            onClick={(e) => {
              if(headCell.label === 'Actions'){
                setShowActions((pre) => !pre)  
              }
            }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={headCell.id !== 'Action' ? createSortHandler(headCell.id) : null}
              hideSortIcon={headCell.id === 'Action'}
            >
              {headCell.id != 'Action' ? (
                <>
                    <Box sx={{ display: 'flex' }}>
                      <Box sx={{ whiteSpace: 'nowrap' }}>{headCell.label}</Box>
                      <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {orderBy === headCell.id ? (
                          <Box
                            //  component="span"
                            sx={visuallyHidden}
                          >
                            {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                          </Box>
                        ) : null}
                        {/* {headCell.id !== "Action" ? (
                          <SearchIcon
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setEnableSearch((prev) => !prev);
                            }}
                            sx={{ marginLeft: "10px" }}
                            fontSize="small"
                          />
                        ) : null} */}
                      </Box>
                    </Box>
                  {/* <IconButton sx={{ margin: '0px 2px', padding: '5px', }}>
                    <FilterAltIcon fontSize='small' sx={{ color: 'primary.main' }} />
                  </IconButton> */}
                </>
              ) : (
                <Box 
                  sx={{
                    display:"flex",
                    alignItems:"center",
                    backgroundColor:headCell.id === "Action" ? "white" : 'background.tablebg',
                    }}
                  >
                    {headCell.label}
                    {
                      (headCell.id === "Action") && (scroll) ? 
                      <ArrowCircleRight
                        sx={{
                         transition: 'transform 0.3s ease-in-out',
                         marginLeft: '10px',
                         transform : scroll ? (!showActions ?  'rotate(0deg)' : 'rotate(180deg)') : "rotate(180deg)",
                         color:scroll ? (!showActions ? 'gray' : '#ee5b2b') : ('#ee5b2b'),
                        }}
                        fontSize="small"
                    />  : null
                    }
                      
                </Box>
              )}
            </TableSortLabel>
          </Box>
        </TableCell>
      ))}
      {/* <TableCell></TableCell> */}
      {numSelected > 0 ? (
        <TableCell>
          <ThreeDot
            onDelete={() => {
              if (Freeze === 1) {
                return handleFreeze();
              }
              onDelete(true);
            }}
          />
        </TableCell>
      ) : null}
    </TableRow>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

function AllAccounts() {
  const { theme } = useThemes();

  const [updateModal, setUpdateModal] = useState(false);
  const [selectedRowModal, setSelectedRowModal] = useState([]);
  const [updatedata, setUpdatedata] = useState('');
  const [groupName, setGroupName] = useState('');
  const location = useLocation();
  const dispatch = useDispatch();
  dispatch(display());
  const { saveSkipStatus } = useSelector((state) => state.companySipSaveReducer);
  const navigate = useNavigate();
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('accountname');
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(defaultRowsPerPage);
  const [deleteModalStatus, setDeleteModalStatus] = useState(false);
  const [rows, setRows] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [accountID, setAccountID] = useState('');
  const [openPartyModal, setOpenPartyModal] = useState(false);
  const [viewParty, setViewParty] = useState(false);
  const [partyDetails, setPartyDetails] = useState();
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [ledgerOpen, setLedgerOpen] = useState(false);
  const [editLedgerOpen, setEditLedgerOpen] = useState(false);
  const [path, setPath] = useState();
  const [ledgerDetails, setLedgerDetails] = useState({
    group: { accountTypeCD: '', label: '', value: '' },
    name: '',
    accountsID: '',
    cess: '',
    cessType: '',
    displayOrderNo: '',
    gstrate: '',
    hsnCode: { label: '', value: '' },
    name: '',
  });

  

  const [deleteSelectedModal, setDeleteSelectedModal] = useState(false);
  const [activeValueModal, setActiveValueModal] = useState();
  const [newId, setNewId] = useState();
  const [newPartyId, setNewPartyId] = useState();
  const [showActions,setShowActions] = useState(true)

  const {
    data: AccountMasterList,
    isLoading: isAccountMasterLoading,
    isError: AccountMasterError,
    refetch: refetchAccountMasterList,
  } = useListAccountMasterv2Query(undefined, {
    refetchOnMountOrArgChange: true,
  });

  const {
    data: AccountBalanceList,
    isLoading: isAccountBalanceLoading,
    isError: AccountBalanceError,
  } = useListAccountBalanceQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (newPartyId) {
      setNewId();
    }
  }, [newId, newPartyId]);

  console.log({ editLedgerOpen });

  useEffect(() => {
    const controlAndS = (e) => {
      const id = document.getElementById('companySetup');
      if (e.ctrlKey && e.key.toLowerCase() === 's' && !ledgerOpen && !editLedgerOpen && !id) {
        e.preventDefault();
        // showErrorSnackbar("Nothing to save");
      }
    };

    document.addEventListener('keydown', controlAndS);

    return () => {
      document.removeEventListener('keydown', controlAndS);
    };
  }, [ledgerOpen, editLedgerOpen]);

  const defaultFilterColumns = {
    accountname: '',
    accountgroupname: '',
    accounttypecd: '',
    accountbalance: '',
    accountcreationdate: '',
    accounttypecdshow: '',
  };

  const [filterColumns, setFilterColumns] = useState(defaultFilterColumns);
  console.log({ filterColumns });
  const handleResetFilterColumns = (status) => {
    if (status === false) {
      setFilterColumns(defaultFilterColumns);
      filterBySearch(
        {
          target: {
            value: '',
            name: '',
          },
        },
        ''
      );
    }
  };

  // State to manage the anchor element for the popover

  const [ListSelection, setListSelection] = useState('All');

  const [circularOpen, setCircularOpen] = useState(true);

  const [gstStatus, setGstStatus] = useState('');
  const handleRequestSort = (event, property) => {
    console.log(property);
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked && filteredList.length) {
      const newSelected = filteredList.map((n) => n.accountsid);
      setSelected(newSelected);
      return;
    }
    setDeleteSelectedModal(false);
    setSelected([]);
  };

  function sortArrayByKey(array, key) {
    array.sort((a, b) => b.accountsid - a.accountsid);
    if (key == 'accountcreationdate') {
      const [day, month, year] = key.split('-').map(Number);
      const dateObject = new Date(year, month - 1, day);
      const timestamp = Math.floor(dateObject.getTime() / 1000);
      key = timestamp;
    }
    if (order == 'asc') {
      return array.sort((a, b) => {
        if (a[key] > b[key]) return -1;
        if (a[key] < b[key]) return 1;
        return 0;
      });
    } else {
      return array.sort((a, b) => {
        if (a[key] < b[key]) return -1;
        if (a[key] > b[key]) return 1;
        return 0;
      });
    }
  }

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const combinedData = useMemo(() => {
    if (!AccountMasterList || !AccountBalanceList) return [];
    const data = AccountMasterList.map((elem) => {
      return {
        ...elem,
        accountbalance: AccountBalanceList?.find((elems) => elems.accountid == elem.accountsid)?.accountbalance,
        accountcreationdate: formatUnixTimestamp(elem.accountcreationdate),
        accounttypecdshow: elem.accounttypecd === 'PandL' ? 'Profit and Loss' : elem.accounttypecd === 'BS' ? 'Balance Sheet' : '',
        accounttypecd: elem.accounttypecd,
      };
    });
    setFilteredList(data);
    return data;
  }, [AccountMasterList, AccountBalanceList]);

  let params = location.state;

  useEffect(() => {
    setBackdropOpen(true);

    if (params?.add) {
      setLedgerOpen(true);
      navigate('/accounts');
    }
  }, []);

  const filterBySearch = (event, category) => {
    setPage(0);
    const query = event?.target?.value;
    const name = event?.target?.name;
    if (name) {
      const obj = { ...filterColumns };
      for (const key in obj) {
        if (key == name) {
          obj[key] = query;
        }
      }
      setFilterColumns(obj);
    }

    var updatedList = [...combinedData];
    if (query !== '') {
      updatedList = updatedList.filter((item) => {
        if (item[category] !== undefined && item[category] !== null) {
          return item[category].toString().toLowerCase().indexOf(query.toLowerCase()) !== -1;
        }
      });
      setFilteredList(updatedList);
    } else {
      setFilteredList(combinedData);
    }
  };

  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);

  async function getCompanyDetails() {
    try {
      setGstStatus(getCompany.relatedcompanydetailsnew[0].registrationtype);
    } catch (error) {
      console.log('error', error);
    }
  }
  useEffect(() => {
    getCompanyDetails();
  }, [getCompany]);

  const [updateAccountMaster] = useUpdateAccountMasterMutation();

  const markAsInActive = async (data, index) => {
    try {
      const updateInput = {
        accountgroupid: data?.accountgroupid,
        accountname: data.accountname,
        accounttypecd: data?.accounttypecd,
        accountsid: data.accountsid,
        companybranchid: data?.companybranchid,
        hsnsaccode: data?.hsnsaccode,
        accounttypeflag: data?.accounttypeflag || 1,
        is_active: data.is_active ? 0 : 1,
      };
      const resUpdateLedger = await updateAccountMaster({
        updateAccountMasterInput: updateInput,
      });
      if (resUpdateLedger.data.statuscode == 'Success') {
        showSuccessSnackbar(`Ledger marked as ${data.is_active ? 'inactive' : 'active'} !`);
      } else showWarningSnackbar(resUpdateLedger.data.statusmessage);
    } catch (error) {
      console.log(error);
    }
  };

  var date = new Date(),
    y = date.getFullYear();
  var firstDay = new Date(y, 0, 1);
  var lastDay = new Date(y, 12, 0);
  const [ledgerModalStartDate, setLedgerModalStartDate] = useState(Math.floor(new Date(firstDay).getTime() / 1000));
  const [ledgerModalEndDate, setLedgerModalEndDate] = useState(Math.floor(new Date(lastDay).getTime() / 1000));
  const userPreferenceAndFY = useSelector((state) => state?.userPrefrenceandReducer);
  async function getUserPreferences() {
    try {
      let startDate = userPreferenceAndFY?.financialYear?.startdate;
      let endDate = userPreferenceAndFY?.financialYear?.enddate;
      // console.log(endDate, startDate);
      setLedgerModalStartDate(startDate);
      setLedgerModalEndDate(endDate);
      setBackdropOpen(false);
    } catch (error) {
      setBackdropOpen(false);
      console.log(error);
    }
  }

  useEffect(() => {
    getUserPreferences();
    return () => {};
  }, [userPreferenceAndFY]);

  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setdeleteId] = useState('');
  const [selectedRow, setSelectedRow] = useState([]);

  const [deleteAccountMaster] = useDeleteAccountMasterMutation();

  async function deleteAccounts() {
    try {
      setBackdropOpen(true);
      const resDeleteLedger = await deleteAccountMaster({
        accountsid: deleteId.id,
      });
      if (!resDeleteLedger || !resDeleteLedger.data) {
        throw new Error('Unexpected response structure. Please try again.');
      }

      const { statuscode, statusmessage } = resDeleteLedger.data;

      if (statuscode === 'Error') {
        if (statusmessage.includes('Transactions Already Recorded')) {
          showWarningSnackbar('Cannot delete ledger account : Transactions exists in the current year');
        } else {
          showWarningSnackbar(statusmessage);
        }
      } else {
        showSuccessSnackbar('Ledger Deleted');
      }
    } catch (error) {
      console.error('Error deleting account:', error);
      if (error.response?.data?.message) {
        showErrorSnackbar(error.response.data.message);
      } else if (error.message) {
        showErrorSnackbar(error.message);
      } else {
        showErrorSnackbar('An unexpected error occurred. Please try again.');
      }
    } finally {
      setBackdropOpen(false);
    }
  }

  useEffect(() => {
    if (deleteId !== '') {
      deleteAccounts();
      setdeleteId('');
    }
  }, [deleteId]);
  const [ledgerData, setLedgerData] = useState('');
  const [disablePopup, setDisablePopup] = useState(false);
  const [gstData, setGstData] = useState('');

  // Mutation hook
  const [createAccountMaster] = useCreateAccountMasterMutation();

  const [createAccountGSTDetails] = useCreateAccountGSTDetailsMutation();

  async function createLedgers() {
    try {
      setBackdropOpen(true);
      const response = await createAccountMaster({
        createAccountMasterInput: ledgerData,
      });

      if (response?.error) {
        showWarningSnackbar(response?.error?.message);
      } else {
        const gstDetails = {
          accountid: response?.data?.accountsid,
          effectivedate: gstData.effectivedate,
          expireddate: gstData.expireddate,
          gstcompensationtype: gstData.gstcompensationtype,
          gstrate: Number(gstData.gstrate),
          hsnid: gstData.hsnid,
          cessamount: gstData.cessamount == '' ? 0 : Number(gstData.cessamount),
        };
        await createAccountGSTDetails({
          createAccountGSTDetailsInput: gstDetails,
        });
        showSuccessSnackbar('Ledger Created Successfully');
        setNewId(response?.data?.accountsid);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setBackdropOpen(false);
    }
  }
  useEffect(() => {
    if (ledgerData) createLedgers();
  }, [ledgerData]);

  const viewFn = (event, row) => {
    event.stopPropagation();
    event.preventDefault();
    if (row?.accountsid !== '') {
      setAccountID(row?.accountsid);
    }
  };
  const [EnableSearch, setEnableSearch] = useState(false);
  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);
  const [headForLedger, setHeadForLedger] = useState();

  const handleEnableEdit = () => {
    setOpenPartyModal(true);
    setViewParty(false);
  };

  const { openLedgerModal, closeLedgerModal, ledgerModalParams } = useLedgerModalHandle();

  const handleIncvalidate = ({accountsId}) => {
    dispatch(listAccountMasterv2Api.util.invalidateTags(
      ['listAccountMaster']
    ))
    console.log({accountsId})
   setNewId(accountsId)
  }
  const allAccountRef = useRef ()
  const [scroll,setScroll] = useState(false)
    useEffect(() => {
    if (filteredList.length > 0 && circularOpen) {
      const width = allAccountRef.current?.offsetWidth;
      const screenWidth = window.innerWidth;
      if (width < screenWidth) {
      setScroll(false)
      } else {
        setScroll(true);
      }
    }
  }, [filteredList, circularOpen]);

  return (
    <Box>
      {editLedgerOpen && (
        <EditToAccount
          passFn={() => {}}
          open={editLedgerOpen}
          disable={true}
          disableAll={disablePopup}
          setOpen={(value) => {
            setEditLedgerOpen(value);
            // setSelectedRowModal([]);
          }}
          purchaseAccDetails={ledgerDetails}
          setUpdateModal={setUpdateModal}
          setSelectedRow={setSelectedRowModal}
          setHeadForLedger={setHeadForLedger}
          selectedPath={path}
          setNewPartyId={setNewPartyId}
          setNewId={setNewId}
          setDisablePopup={setDisablePopup}
        />
      )}

      {ledgerOpen && (
        <CreateLedger
          head={headForLedger}
          open={ledgerOpen}
          setOpen={setLedgerOpen}
          disable={false}
          setLedgerData={setLedgerData}
          setNewId={setNewId}
          setNewPartyID={setNewPartyId}
          setGstData={setGstData}
          passFn={() => {}}
          name={selectedRowModal.name}
          groupName={selectedRowModal.defaultGroupId}
        />
      )}

      <ConfirmDeleteModal open={deleteModalStatus} setOpen={setDeleteModalStatus} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderTopRightRadius: '12px',
          borderTopLeftRadius: '12px',
          padding: '8px 10px',
          backgroundColor: 'primary.main',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flex: { xs: 1, sm: 0 },
            justifyContent: 'space-between',
          }}
        >
          <Box sx={{ display: 'flex' }}>
            {/* <Link className="link-thex link-the" to={'/accounts'}>
              <Box
                sx={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: { sm: '10px 16px', xs: '10px 10px' },
                  backgroundColor: 'white',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  color: 'primary.main',
                  margin: '0px 5px',
                  transition: 'ease-in-out .4',
                }}
                // onClick={() => navigate('/goodslist')}
              >
                <CommitSharp
                  sx={{
                    fontSize: '20px',
                    display: { xs: 'none', sm: 'block' },
                  }}
                />
                <Typography
                  sx={{
                    color: 'primary.main',
                    fontSize: '12px',
                    marginLeft: { sm: '5px', xs: '0' },
                  }}
                >
                  Ledgers
                </Typography>
              </Box>
            </Link>
            <Link className="link-thex link-the" to={'/groups'}>
              <Box
                sx={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: { sm: '10px 16px', xs: '10px 10px' },
                  backgroundColor: 'primary.main',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  transition: 'ease-in-out .4',
                  color: 'white',
                  ':hover': {
                    backgroundColor: 'primary.main',
                    color: '#f1ededeb',
                  },
                }}
                onClick={() => {
                  navigate('/groups');
                }}
              >
                <GroupWork
                  sx={{
                    fontSize: '20px',
                    display: { xs: 'none', sm: 'block' },
                  }}
                />
                <Typography
                  sx={{
                    color: 'white',
                    fontSize: '12px',
                    marginLeft: { sm: '5px', xs: '0' },
                    ':hover': {
                      backgroundColor: 'primary.main',
                      color: '#f1ededeb',
                    },
                  }}
                >
                  Groups
                </Typography>
              </Box>
            </Link> */}

            <FormControl size="small"
                sx={{
                  minWidth: {xs:100,sm:160},
                  backgroundColor: "white",
                  borderRadius: "6px",
                  boxShadow: 1,
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                  "& .MuiSelect-icon": {
                    color: globalColors.primary, 
                  },
                }}>
              <Select
                displayEmpty
                value=""
                renderValue={(selected) => {
                  if (selected === "") {
                    return <span style={{ color:globalColors.primary}}>Ledger</span>;
                  }
                  return selected;
                }}
                onChange={()=> navigate("/groups")}
                 MenuProps={{
                  PaperProps: {
                    sx: {
                      backgroundColor: "white",
                      boxShadow: 3,
                    },
                  },
                }}
              >
                <MenuItem 
                    sx={{color:globalColors.primary, 
                      "&:hover": { backgroundColor: "white" }, 
                      "&.Mui-focusVisible": {
                        backgroundColor: "transparent", 
                      },
                  }}
                    >
                  Group
                </MenuItem>  
              </Select>
            </FormControl>
          </Box>
          <Button
            sx={{
              whiteSpace: 'nowrap',
              border: '1px solid white',
              boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.5)',
              ml: 1,
              fontWeight: 'bold',
              backgroundColor: 'white',
              '&:hover': {
                backgroundColor: 'white', // Override hover background color
              },
            }}
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={(e) => {
              if (Freeze == 1) {
                return handleFreeze();
              }
              if (saveSkipStatus == false) {
                if (window.location.href.includes('companysetup')) {
                  showWarningSnackbar('Please Complete the Company Setup Details');
                }
                e.preventDefault();
                dispatch(settingsClose());
                return navigate('/companysetup');
              }
              // setNewPartyId();
              // setLedgerOpen(true);
              openLedgerModal({
                accountId : ''
              })
            }}
          >
            Add Ledger
          </Button>
            <Box sx={{display:{xs:'flex',sm:'none',justifyContent:'center',alignItems:'center'}}}>
            <TableSearchButton
            setEnableSearch={setEnableSearch}
            EnableSearch={EnableSearch}
            id={'accountsSearch'}
            onClick={handleResetFilterColumns}
            />
          </Box>
          
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box sx={{display:{xs:'none',sm:'block'}}}>
            <TableSearchButton
            setEnableSearch={setEnableSearch}
            EnableSearch={EnableSearch}
            id={'accountsSearch'}
            onClick={handleResetFilterColumns}
            />
          </Box>
          
          <Box
            sx={{
              display: {
                xs: 'none',
                sm: 'flex',
                md: 'flex',
                lg: 'flex',
                xl: 'flex',
              },
            }}
          >
            <Typography
              sx={{
                fontSize: '13px',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              Total : {filteredList.length} Items{' '}
              {selected.length != 0 ? `(Selected Items :${selected.length}/${filteredList.length})` : ''}
            </Typography>
            <DropDownForListing
              name={'ser'}
              list={[
                { label: 'All', value: 'All' },
                { label: 'Active', value: 'Active' },
                { label: 'In-Active', value: 'InActive' },
              ]}
              value={ListSelection}
              onChange={(e) => {
                setListSelection(e.target.value);
                setPage(0);
              }}
            />
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          boxShadow: 'rgb(33 35 38 / 10%) 0px 10px 10px -10px',
          borderBottomRightRadius: '12px',
          borderBottomLeftRadius: '12px',
          // backgroundColor: theme.palette.bodyGray.secondary,
          padding: {},
          '.css-1mxz8qt-MuiPaper-root': {
            boxShadow: 'none',
          },
          '.MuiTableCell-root': {
            padding: '0px 10px',
            fontSize: '13px',
          },
          '.MuiTableCell-head': {
            backgroundColor: 'background.tablebg',
            padding: '0px 10px',
            borderBottom: '0px',
          },
        }}
      >
        <Box
          sx={{
            width: '100%',
            overflow: 'hidden',
            boxShadow: 'none',
            // backgroundColor: theme.palette.bodyGray.secondary,
          }}
        >
          <TableContainer
            className="custom-scrollbar"
            sx={{
              height: {
                sm: 'calc( 100vh - 230px )',
                xs: 'calc( 100vh - 180px )',
              },
            }}
          >
            <Table
              stickyHeader
              aria-label="sticky table"
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={dense ? 'small' : 'medium'}
            >
              <TableHead>
                <EnhancedTableHead
                  EnableSearch={EnableSearch}
                  setEnableSearch={setEnableSearch}
                  numSelected={selected.length}
                  order={order}
                  orderBy={orderBy}
                  onSelectAllClick={handleSelectAllClick}
                  onRequestSort={handleRequestSort}
                  rowCount={filteredList.length}
                  onDelete={() => setDeleteSelectedModal(true)}
                  setShowActions = {setShowActions}
                  showActions = {showActions}
                  scroll = {scroll}
                />
              </TableHead>
              {console.log({ filteredList, order, orderBy })}

              <TableBody ref={allAccountRef}>
                {EnableSearch == true && (
                  <TableRow
                  className='noTableCellBorder'
                    sx={{
                      '& .MuiTableCell-head': { top: 38, zIndex: 1 },
                      '.MuiTableCell-root': {
                        backgroundColor: 'transparent !important',
                        padding: '1px 10px',
                        fontSize: '13px',
                      },
                      '.css-wrnu0i-MuiInputBase-root': {
                        fontSize: '13px',
                      },
                      '.css-xk0adg-MuiButtonBase-root-MuiIconButton-root': {
                        padding: '2px 4px',
                      },
                      '.css-1gqfvv-MuiPaper-root': {
                        boxShadow: 'none',
                        borderBottom: 'solid 1px rgba(0,0,0,0.24)',
                        borderRadius: '0px',
                      },
                    }}
                  >
                    <TableCell></TableCell>
                    <TableCell>
                      <Paper
                        id="accountsSearch"
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <InputBase
                          name="accountname"
                          value={filterColumns.accountname}
                          onChange={(e) => filterBySearch(e, 'accountname')}
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ padding: '0px' }}>
                          {filterColumns.accountname !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  accountname: '',
                                }));
                                setFilteredList(combinedData);
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell>
                    <TableCell>
                      <Paper
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <InputBase
                          name="accountgroupname"
                          value={filterColumns.accountgroupname}
                          onChange={(e) => filterBySearch(e, 'accountgroupname')}
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ padding: '0px' }}>
                          {filterColumns.accountgroupname !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  accountgroupname: '',
                                }));
                                setFilteredList(combinedData);
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell>
                    <TableCell>
                      <Paper
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <InputBase
                          name="accounttypecdshow"
                          value={filterColumns.accounttypecdshow}
                          onChange={(e) => filterBySearch(e, 'accounttypecdshow')}
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ padding: '0px' }}>
                          {filterColumns.accounttypecdshow !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  accounttypecdshow: '',
                                }));
                                setFilteredList(combinedData);
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell>
                    <TableCell>
                      <Paper
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <InputBase
                          name="accountbalance"
                          value={filterColumns.accountbalance}
                          onChange={(e) => filterBySearch(e, 'accountbalance')}
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ padding: '0px' }}>
                          {filterColumns.accountbalance !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  accountbalance: '',
                                }));
                                setFilteredList(combinedData);
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell>
                    <TableCell>
                      <Paper
                        sx={{
                          p: '2px 4px',
                          display: 'flex',
                          alignItems: 'center',
                          width: '100%',
                        }}
                      >
                        <InputBase
                          name="accountcreationdate"
                          value={filterColumns.accountcreationdate}
                          onChange={(e) => filterBySearch(e, 'accountcreationdate')}
                          sx={{ flex: 1 }}
                          placeholder="Search"
                          autoComplete="off"
                        />
                        <IconButton type="button" sx={{ padding: '0px' }}>
                          {filterColumns.accountcreationdate !== '' ? (
                            <Clear
                              fontSize="small"
                              onClick={() => {
                                setFilterColumns((prev) => ({
                                  ...prev,
                                  accountcreationdate: '',
                                }));
                                setFilteredList(combinedData);
                              }}
                            />
                          ) : (
                            <SearchIcon fontSize="small" />
                          )}
                        </IconButton>
                      </Paper>
                    </TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                )}
                {filteredList.length > 0 ? (
                  sortArrayByKey(filteredList, orderBy)
                    .sort((a, b) => {
                      const aIsNew = a.accountsid === newId || (a.partyid === newPartyId && newPartyId !== undefined);
                      const bIsNew = b.accountsid === newId || (b.partyid === newPartyId && newPartyId !== undefined);

                      if (aIsNew && !bIsNew) return -1;
                      if (!aIsNew && bIsNew) return 1;

                      return getComparator(order, orderBy)(a, b);
                    })
                    // .sort((a,b) => a.accountname.toLowerCase().localeCompare(b.accountname.toLowerCase()))
                    // .sort(getComparator(order, orderBy))
                    .filter((e) => ListSelection_fnForMasters(e, ListSelection))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      const isItemSelected = isSelected(row.accountsid);
                      const labelId = `enhanced-table-checkbox-${index}`;
                      
                      return (
                        <TableRow
                          sx={{
                            '.MuiTableCell-root': {
                              backgroundColor: 'transparent ',
                              borderBottom:"none"
                            },
                            padding: '0px',
                            '& .MuiCheckbox-root': {
                              padding: '4px',
                            },
                          }}
                          className={`noTableCellBorder ${!row.is_active ? 'rowInactiveMuted' : ''}`}
                          hover
                          onClick={(event) => {
                            setDisablePopup(true);
                            if (
                              (row.accountgroupid == 17 && row.accountsid !== 39) ||
                              (row.accountgroupid == 29 && row.accountsid !== 36)
                            ) {
                              setUpdateModal(true);
                              setGroupName(row.accountgroupname);
                              let passRow = {
                                category: 'ledger',
                                type: row.Accounttypecd,
                                groupName: row.accountname,
                                name: row.accountname,
                                id: row.accountsid,
                                _id: row.accountsid + 'Ledger',
                                parent: row.accountgroupid,
                                relatedData: {
                                  CompanyID: row.companyid,
                                  CompanyBranchID: row.companybranchid,
                                  AccountsID: row.accountsid,
                                  Accounttypecd: row.Accounttypecd,
                                  accountname: row.accountname,
                                  AccountGroupID: row.accountgroupid,
                                  accountgroupname: row.accountgroupname,

                                  Credit: 0,
                                  Debit: 0,
                                  BalanceAmount: 0,
                                  TypeCD: 'Ledger',
                                  Restrictedflag: 0,
                                  __typename: row.accounttypecdshow,
                                },
                                defaultGroupId: row.accountgroupid,
                                create: 'edit',
                              };
                              setSelectedRowModal(passRow);
                              //  setDisablePopup(false);
                            } else {
                              if (row.accountgroupid == 15 || row.accountgroupid == 7) {
                                setPartyDetails(row);
                                setOpenPartyModal(true);
                                setViewParty(true);
                                 setDisablePopup(false);
                              } else {
                                setLedgerDetails({
                                  group: {
                                    accountTypeCD: row.accounttypecd,
                                    label: row.accountgroupname,
                                    value: row.accountgroupid,
                                  },
                                  gstrate:
                                    row?.relatedaccountgstdetails?.[0]?.gstrate === undefined
                                      ? ''
                                      : row?.relatedaccountgstdetails?.[0]?.gstrate,
                                  hsnCode: { label: '', value: row.hsnsaccode },
                                  displayOrderNo: row.displayordernumber,
                                  accountsID: row.accountsid,
                                  name: row.accountname,
                                  cess: row.relatedaccountgstdetails?.[0]?.cessamount,
                                  cessType: row.relatedaccountgstdetails?.[0]?.gstcompensationtype,
                                });
                                setPath(row?.path?.split('/'));
                                setEditLedgerOpen(true);
                                //  setDisablePopup(false);
                              }
                            }
                          }}
                          role="checkbox"
                          aria-checked={isItemSelected}
                          tabIndex={-1}
                          key={index}
                          selected={isItemSelected}
                          style={{ cursor: 'pointer' }}
                        >
                          <TableCell
                            title={row.is_active === 1 ? '' : 'Inactive'}
                            padding="none"
                            sx={{
                              padding: '0px',
                              '.css-1mqsplk-MuiButtonBase-root-MuiCheckbox-root': {
                                padding: '5px',
                              },
                              '& .MuiCheckbox-root': {
                                padding: '4px',
                              },
                            }}
                          >
                            <Checkbox
                              onClick={(event) => {
                                event.stopPropagation();
                                handleClick(event, row.accountsid);
                              }}
                              color="primary"
                              checked={isItemSelected}
                              inputProps={{
                                'aria-labelledby': labelId,
                              }}
                              size="small"
                            />
                          </TableCell>
                          <TableCell
                            title={row.is_active === 1 ? '' : 'Inactive'}
                            id={labelId}
                            scope="row"
                            sx={{
                              cursor: 'pointer',
                              // height: '40px',
                              // display: 'flex',
                              // alignItems: 'center',
                              whiteSpace: 'nowrap',
                              padding: '0px',
                              '& .MuiCheckbox-root': {
                                padding: '4px',
                              },
                            }}
                            onClick={(event) => {
                              event.preventDefault();
                            }}
                          >
                            {/* <a
                              underline="hover"
                              style={{
                                cursor: "pointer",
                              }}
                            > */}
                            {row.accountname}
                            {/* </a> */}
                            {(row.accountsid == newId || (row.partyid == newPartyId && newPartyId !== undefined)) && (
                              <Box
                                sx={{
                                  backgroundColor: '#FF004D',
                                  color: '#FFF',
                                  borderRadius: 10,
                                  marginLeft: 1.5,
                                  fontSize: 10,
                                  paddingLeft: 2,
                                  paddingRight: 2,
                                  paddingTop: 0.25,
                                  paddingBottom: 0.25,
                                  display:'inline'
                                }}
                              >
                                New
                              </Box>
                            )}
                          </TableCell>
                          <TableCell
                            align="left"
                            title={row.is_active === 1 ? '' : 'Inactive'}
                            sx={{
                              whiteSpace: 'nowrap',
                              padding: '0px',
                              '& .MuiCheckbox-root': {
                                padding: '4px',
                              },
                            }}
                          >
                            {row.accountgroupname}
                          </TableCell>
                          <TableCell
                            align="left"
                            title={row.is_active === 1 ? '' : 'Inactive'}
                            sx={{
                              padding: '0px',
                              '& .MuiCheckbox-root': {
                                padding: '4px',
                              },
                            }}
                          >
                            {row.accounttypecdshow}
                          </TableCell>
                          <TableCell
                            align="right"
                            title={row.is_active === 1 ? '' : 'Inactive'}
                            title={row.is_active === 1 ? '' : 'Inactive'}
                            sx={{
                              padding: '0px',
                              '& .MuiCheckbox-root': {
                                padding: '4px',
                              },
                            }}
                          >
                            <Box
                              sx={{ mr: 5, color: theme.palette.text.Link }}
                              onClick={(e) => {
                                viewFn(e, row);
                              }}
                            >
                              <a
                                underline="hover"
                                style={{
                                  cursor: 'pointer',
                                }}
                                href={`/LedgerTransactions/${row?.accountsid}`}
                                onClick={(e) => {
                                  viewFn(e, row);
                                }}
                              >
                                {formatNumber(row.accountbalance, true, true, row.balancesign)}
                                {/* {MoneyFormatv3(
                                  Math.abs(Number(row.accountbalance)),
                                  "en-IN"
                                )}{" "}
                                {Math.sign(Number(row.accountbalance)) === -1
                                  ? "Dr"
                                  : "Cr"} */}
                              </a>
                            </Box>
                          </TableCell>
                          <TableCell
                            align="left"
                            title={row.is_active === 1 ? '' : 'Inactive'}
                            sx={{
                              padding: '0px',
                              '& .MuiCheckbox-root': {
                                padding: '4px',
                              },
                            }}
                          >
                            {row.accountcreationdate}
                          </TableCell>
                          <TableCell className="actionBackGround" align="center" sx={{position :!showActions ? 'relative' : 'sticky'}}>
                            <Box
                               className={(row.restrictedflag !== 1 || row.accountsid === 39 || row.accountsid === 36) ?"actionCellStyle" : ""}
                               
                            >
                              {/* Show Active/Inactive and Delete buttons only for non-restricted accounts */}
                              {(row.restrictedflag !== 1 || row.accountsid === 39 || row.accountsid === 36) && (
                                <>
                                  {(row?.accountsid !== 39 && row.accountsid !== 36) && (
                                    <>
                                      <Tooltip
                                        title={row.is_active == 1 ? 'Mark as Inactive' : 'Mark as Active'}
                                        placement="left"
                                        disableInteractive
                                        arrow
                                      >
                                        <IconButton
                                          onClick={(event) => {
                                            event.stopPropagation();
                                            if (Freeze == 1) {
                                              return handleFreeze();
                                            }
                                            if (row.restrictedflag) {
                                              return showWarningSnackbar('Default Ledger Accounts Cannot Be Set To Inactive');
                                            }
                                            setActiveValueModal(row);
                                          }}
                                          aria-label="delete"
                                          sx={{
                                            margin: '0px 2px',
                                            padding: '5px',
                                            // backgroundColor: "#FEF3C7",
                                            backgroundColor: 'white',
                                            border: 'solid 1px black',
                                          }}
                                        >
                                          {row.is_active == 1 ? (
                                            <CheckCircleOutline
                                              sx={{
                                                fontSize: '10px',
                                                // color: "#E29819",
                                                color: 'green',
                                              }}
                                            />
                                          ) : (
                                            <DoDisturbAlt
                                              sx={{
                                                fontSize: '10px',
                                                // color: "#E29819",
                                                color: 'red',
                                              }}
                                            />
                                          )}
                                        </IconButton>
                                      </Tooltip>

                                      <Tooltip title={'Delete'} placement="top" disableInteractive arrow>
                                        <IconButton
                                          onClick={(event) => {
                                            event.stopPropagation();
                                            if (Freeze == 1) {
                                              return handleFreeze();
                                            }
                                            if (row.restrictedflag) {
                                              return showWarningSnackbar('Default Ledger Accounts Cannot Be Deleted');
                                            }
                                            setSelectedRow({
                                              id: row.accountsid,
                                              category: 'ledger',
                                            });
                                            setDeleteModal(true);
                                          }}
                                          aria-label="delete"
                                          sx={{
                                            margin: '0px 2px',
                                            padding: '5px',
                                            // backgroundColor: "#fbc7c7",
                                            backgroundColor: 'white',
                                            border: 'solid 1px black',
                                          }}
                                        >
                                          <Delete
                                            sx={{
                                              fontSize: '10px',
                                              color: '#eb6a6a',
                                            }}
                                          />
                                        </IconButton>
                                      </Tooltip>
                                    </>
                                  )}
                                </>
                              )}
                              
                              {/* Always show Edit button for all accounts */}
                              <Tooltip title={row.is_active == 0 ? 'cannot Edit' : 'Edit'} placement="right" disableInteractive arrow>
                                <IconButton
                                  aria-label="edit"
                                  sx={{
                                    margin: '0px 2px',
                                    padding: '5px',
                                    backgroundColor: '#D0EFFF',
                                    border:"solid 1px black"
                                  }}
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    if (Freeze == 1) {
                                      return handleFreeze();
                                    } 
                                    openLedgerModal({
                                      groupId: row.accountgroupid,
                                      accountId: row.accountsid,
                                      title:row.accountname,
                                      restrictedflag: row?.restrictedflag,
                                    });
                                  }}
                                >
                                  {
                                    row.is_active == 0 ? <EditOff sx={{ fontSize: "10px", color: '#6096d9', }} /> :  <Edit
                                    sx={{
                                      fontSize: '10px',
                                      color: row.is_active == 0 ? '#fff' : '#6096d9',
                                    }}
                                  />
                                  }
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </TableCell>
                        </TableRow>
                      );
                    })
                ) : circularOpen == false ? (
                  <TableRow>
                    <TableCell align="center" height={400} colSpan={8}>
                      No Data Found
                    </TableCell>
                  </TableRow>
                ) : (
                  ''
                )}

                {(isAccountBalanceLoading == true || isAccountMasterLoading) &&
                  rowsPerPage > 0 &&
                  Array.from({ length: rowsPerPage }, (_, index) => (
                    <TableRow  className='noTableCellBorder' key={index}>
                      <TableCell colSpan={12}>
                        <Skeleton variant="text" sx={{ fontSize: '2rem' }} />
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          {filteredList.length > 0 && (
            <TablePagination
              rowsPerPageOptions={defaultRowsPerPageOptions}
              component="div"
              count={filteredList.filter((e) => ListSelection_fnForMasters(e, ListSelection)).length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          )}
        </Box>
      </Box>
      <DeleteLedgerGroup type={'Ledger'} open={deleteModal} setOpen={setDeleteModal} setdeleteId={setdeleteId} selectedRow={selectedRow} />

      <DeleteSelectedLedger
        open={deleteSelectedModal}
        setOpen={setDeleteSelectedModal}
        partysData={selected}
        rows={rows}
        setSelected={setSelected}
        setRows={setRows}
      />
      {updateModal && (
        <UpdateLedgerGroup
          disableAll={disablePopup}
          open={updateModal}
          setOpen={(value) => {
            setUpdateModal(value);
            setSelectedRowModal([]);
          }}
          isVoucher={true}
          groupName={groupName}
          defaultGroupID={selectedRowModal.defaultGroupId}
          selectedRow={selectedRowModal}
          setUpdatedata={setUpdatedata}
          setDisablePopup={setDisablePopup}
        />
      )}

      {activeValueModal && (
        <ListingActive
          text={'Ledger'}
          open={activeValueModal}
          editData={{ serialisactive: activeValueModal?.is_active }}
          setOpen={setActiveValueModal}
          action={() => {
            markAsInActive(activeValueModal);
          }}
        />
      )}

      {openPartyModal === true && (
        <AddNewPartyModal
          view={viewParty}
          open={openPartyModal}
          setOpen={setOpenPartyModal}
          setNewPartyID={(value) => {
            if (value) {
              refetchAccountMasterList();
            }
          }}
          partyParamsID={partyDetails?.partyid}
          partyType={partyDetails.accountgroupid == 7 ? 'supplier' : partyDetails.accountgroupid == 15 ? 'customer' : 'Add Party'}
          Type={'Party'}
          page="Balance Sheet"
          passFn={handleEnableEdit}
          newPartyName={partyDetails?.accountname}
        />
      )}
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
        <CircularProgress color="inherit" />
      </Backdrop>
      {accountID && <LedgerTransactionModalv2 open={accountID} includingOpeningBalance={1} accountId={accountID} onClose={() => setAccountID('')} />}
      <LedgerModal {...ledgerModalParams} onSave={handleIncvalidate} onClose={closeLedgerModal} />
    </Box>
  );
}

export default AllAccounts;
